import React, { useEffect, useState } from 'react';
// import './Management3.css';
import image from "../../../images/wallet.avif";
import axios from 'axios';
import Settlement from '../Accountandhistory/Food/Settlement';


// all the data formated code also not digital formated in the re

const Logisticsaccountsdata = () => {
  const [activeTab, setActiveTab] = useState('Overview');
  const [vendorId, setVendorId] = useState(null);
  const isMobile = useState(window.innerWidth < 768);
  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) {
      setVendorId(storedVendorId);
    }
  }, []);
  const [totals, setTotals] = useState({
    totalIncome: 0,
    walletIncome: 0,
    onlineIncome: 0,
    cashIncome: 0,
  });

  const datta = [
    {
      sno: 1,
      orderId: 'ORD001',
      userName: 'Ravi Kumar',
      subscription: 'Pro',
      dateTime: '15-03-2025',
      enddate: '14-06-2025',
      amount: 1299,
      status: 'Refunded',
      reason: 'Product damaged',
    },
    {
      sno: 2,
      orderId: 'ORD002',
      userName: 'Meena Shah',
      subscription: 'Standard',
      dateTime: '15-03-2025',
      enddate: '14-06-2025',
      amount: 899,
      status: 'Refunded',
      reason: 'Late delivery',
    },
    {
      sno: 3,
      orderId: 'ORD003',
      userName: 'Suman Rao',
      subscription: 'Basic',
      dateTime: '15-03-2025',
      enddate: '14-06-2025',
      amount: 499,
      status: 'Cancelled',
      reason: 'Customer cancelled before shipping',
    },
  ];
  const getStatusColor = (status) => {
    if (status === 'Refunded') return 'green';
    if (status === 'Cancelled') return '#888';
    return 'orange';
  };




  const [data, setData] = useState([]);
  useEffect(() => {
    if (!vendorId) return;

    const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage
    if (!token) {
      console.error("Authorization token is missing");
      return;
    }

    axios
      .get(
        `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ Attach token to request
          },
        }
      )
      .then((res) => {
        const orders = res.data;
        setData(orders);

        let walletIncome = 0;
        let onlineIncome = 0;
        let cashIncome = 0;

        orders.forEach((order) => {
          if (order.paymentStatus?.toLowerCase() === "paid") {
            const amount = order.grandTotal || 0;
            const paymentMethod = order.paymentMethod?.toLowerCase();

            if (paymentMethod === "maamaas_wallet") {
              walletIncome += amount;
            } else if (paymentMethod === "online_payment") {
              onlineIncome += amount;
            } else if (paymentMethod === "cash") {
              cashIncome += amount;
            }
          }
        });

        const totalIncome = walletIncome + onlineIncome + cashIncome;
        setTotals({ walletIncome, onlineIncome, cashIncome, totalIncome });
      })
      .catch((err) => console.error("Error fetching orders:", err));
  }, [vendorId]);

  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [weekDay, setWeekDay] = useState("");
  const [day, setDay] = useState("");

  const handleYearChange = (e) => setYear(e.target.value);
  const handleMonthChange = (e) => setMonth(e.target.value);
  const handleWeekChange = (e) => setWeekDay(e.target.value);
  const handleDayChange = (e) => setDay(e.target.value);

  const filteredData = data.filter((item) => {
    const date = new Date(item.orderDateAndTime);
    const orderYear = date.getFullYear().toString();
    const orderMonth = date.toLocaleString("default", { month: "short" });
    const orderDay = date.getDate().toString().padStart(2, '0');
    const orderWeekDay = date.toLocaleString("default", { weekday: "short" });

    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    let pass = true;

    if (year && year !== "Yearly") pass = pass && year === orderYear;
    if (month && month !== "Monthly") pass = pass && month === orderMonth;
    if (weekDay && weekDay !== "Weekly") pass = pass && weekDay === orderWeekDay;
    if (day && day !== "Today") {
      if (day === "Yesterday") {
        pass = pass && date.toDateString() === yesterday.toDateString();
      } else {
        const [dd, mm, yy] = day.split("/");
        const customDate = new Date(`20${yy}-${mm}-${dd}`);
        pass = pass && date.toDateString() === customDate.toDateString();
      }
    } else if (day === "Today") {
      pass = pass && date.toDateString() === today.toDateString();
    }

    return pass;
  });

  // {=======================overview===============================}
  const tabContent = {
    Overview: <div style={{ marginTop: "20px" }}>
      <div className="status-overview">
        {[
          { title: "Total Income", value: totals.totalIncome },
          { title: "Wallet Income", value: totals.walletIncome },
          { title: "Online Income", value: totals.onlineIncome },
          { title: "Cash Income", value: totals.cashIncome },
        ].map((card, idx) => (
          <div key={idx} style={{ background: "#2c6eaa", color: "#fff" }} className="status-card dine-in">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "30px", marginTop: '20px' }}>
              <img src={image} alt="icon" style={{ height: '50px', borderRadius: '10px' }} />
            </div>
            <h4 style={{ display: 'flex', justifyContent: "center" }}>{card.title}</h4>
            <p style={{ fontWeight: "bold", display: 'flex', justifyContent: "center" }}>₹{card.value.toLocaleString("en-IN")}</p>
          </div>
        ))}
      </div>
      <div className="status-overview">
      </div>



      <div className="payment-history-container">
        <style>
          {`
          .payment-history-container {
           
            box-sizing: border-box;
            width: 100%;
            max-width: 100%;
          }

          .payment-heading {
            text-align: center;
            margin-bottom: 15px;
            font-size: 20px;
          }

          .filter-bar {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            gap: 10px;
            margin-bottom: 15px;
            align-items: center;
          }

          .filter-group {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
          }

          .filter-group select {
            padding: 6px;
            background-color:#b15dc6;
            color: white;
            font-weight:bold;
            border-radius: 5px;
            border: 1px solid #ccc;
            min-width: 100px;
            font-size: 14px;
          }

          .export-button {
            padding: 4px 8px;
            background-color: #b15dc6;
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            font-size: 14px;
            white-space: nowrap;
           
          }

          .table-wrapper {
            width: 100%;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            background: #fff;
            // border: 1px solid #ddd;
            border-radius: 8px;
          }

          table {
            width: 100%;
            min-width: 850px;
            border-collapse: collapse;
          }

          th, td {
            border: 1px solid #ddd;
            padding: 10px;
            font-size: 13px;
            text-align: left;
            white-space: nowrap;
          }

          th {
            background-color: #b15dc6;
            font-weight: bold;
            font-size: 14px;
          }

          tr:nth-child(even) {
            background-color: #ffffff;
          }

          tr:nth-child(odd) {
            background-color: #f9f9f9;
          }

          @media screen and (max-width: 768px) {
            .filter-bar {
              //  flex-direction: column;
              align-items: flex-start;
            }




             @media screen and (max-width: 480px) {
            .filter-bar {
              //  flex-direction: column;
              align-items: flex-start;
            }

            .payment-history-container{
            max-width:100%;
            padding:0px;
            }
            

            .export-button {
              align-self: flex-end;
            }

            .table-wrapper {
              border: 1px;
              border-radius: 0;
              padding-bottom: 10px;
            }

            table {
              min-width: 600px;
            }
          }
        `}
        </style>

        <h4 className="payment-heading">Payment History</h4>

        <div className="filter-bar">
          <div className="filter-group">
            <select value={year} onChange={handleYearChange}>
              <option>Yearly</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
            </select>

            <select value={month} onChange={handleMonthChange}>
              <option>Monthly</option>
              <option value="Jan">Jan</option>
              <option value="Feb">Feb</option>
              <option value="Mar">Mar</option>
            </select>

            <select value={weekDay} onChange={handleWeekChange}>
              <option>Weekly</option>
              <option value="Sun">Sun</option>
              <option value="Mon">Mon</option>
              <option value="Tue">Tue</option>
            </select>

            <select value={day} onChange={handleDayChange}>
              <option>Today</option>
              <option value="Yesterday">Yesterday</option>
              <option value="25/03/25">25/03/25</option>
              <option value="24/03/25">24/03/25</option>
            </select>
          </div>

          <button className="export-button">Export</button>
        </div>

        <div style={{ marginTop: "-40px" }} className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>OrderID</th>
                <th>Transaction ID</th>
                <th>Date & Time</th>
                <th>Name</th>
                <th>Payment</th>
                <th>Status</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.orderId}</td>
                  <td>{item.transactionId}</td>
                  <td>{new Date(item.orderDateAndTime).toLocaleString()}</td>
                  <td>{item.userName}</td>
                  <td>{item.paymentMethod}</td>
                  <td>{item.paymentStatus}</td>
                  <td>₹{Math.round(item.grandTotal)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>,


    // {=======================all===============================}
    Settlement: <Settlement />,


    // {=======================Cancel===============================}

    // "Cancel/Refund": <div>
    //   <div style={{ display: "flex", gap: "10px", justifyContent: "space-between", marginTop: "-15px" }}>
    //     <div>
    //       <select style={{ height: "35px", marginTop: '20px', marginRight: "10px", borderRadius: "4px", fontWeight: "bold", backgroundColor: "#b15cd6", color: "#fff", marginBottom: "5px" }}>
    //         <option value="yearly">Yearly</option>
    //         <option value="yearly">2023</option>
    //         <option value="yearly">2024</option>
    //         <option value="yearly">2025</option>
    //       </select>
    //       <select style={{ height: "35px", marginTop: '20px', marginRight: "10px", borderRadius: "4px", fontWeight: "bold", backgroundColor: "#b15cd6", color: "#fff", marginBottom: "5px" }}>
    //         <option value="yearly">Monthly</option>
    //         <option value="yearly">Jan</option>
    //         <option value="yearly">Feb</option>
    //         <option value="yearly">Mar</option>
    //       </select>
    //       <select style={{ height: "35px", marginTop: '20px', marginRight: "10px", borderRadius: "4px", fontWeight: "bold", backgroundColor: "#b15cd6", color: "#fff", marginBottom: "5px" }}>
    //         <option value="yearly">Weekly</option>
    //         <option value="yearly">sun</option>
    //         <option value="yearly">Mon</option>
    //         <option value="yearly">Tues</option>
    //       </select>
    //       <select style={{ height: "35px", marginTop: '20px', marginRight: "10px", borderRadius: "4px", fontWeight: "bold", backgroundColor: "#b15cd6", color: "#fff", marginBottom: "5px" }}>
    //         <option value="yearly">Today</option>
    //         <option value="yearly">Yesterday</option>
    //         <option value="yearly">25/03/25</option>
    //         <option value="yearly">24/03/25</option>
    //       </select>
    //     </div>
    //     <div>
    //       <button style={{ height: '35px', marginTop: "20px", borderRadius: "4px", border: "none", backgroundColor: "#b15cd6", color: "white", fontWeight: 'bold', marginRight: "10px" }}>Import</button>
    //       <button style={{ height: '35px', marginTop: "20px", borderRadius: "4px", border: "none", backgroundColor: "#b15cd6", color: "white", fontWeight: 'bold', }}>Export</button>
    //     </div>
    //   </div>
    //   <table style={{ borderCollapse: 'collapse', marginTop: "0px" }}>
    //     <thead>
    //       <tr style={{ backgroundColor: '#f2f2f2' }}>
    //         <th style={tableHeaderStyle}>S.No</th>
    //         <th style={tableHeaderStyle}>Order ID</th>
    //         <th style={tableHeaderStyle}>User Name</th>
    //         <th style={tableHeaderStyle}>Date & Time</th>
    //         <th style={tableHeaderStyle}>Amount</th>
    //         <th style={tableHeaderStyle}>Status</th>
    //         <th style={tableHeaderStyle}>Reason</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       {datta.map((item, index) => (
    //         <tr key={index} style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
    //           <td style={tableCellStyle}>{item.sno}</td>
    //           <td style={tableCellStyle}>{item.orderId}</td>
    //           <td style={tableCellStyle}>{item.userName}</td>
    //           <td style={tableCellStyle}>{item.dateTime}</td>
    //           <td style={tableCellStyle}>₹{item.amount}</td>
    //           <td style={tableCellStyle}>
    //             <span
    //               style={{
    //                 color: getStatusColor(item.status),
    //                 fontWeight: 'bold',
    //               }}
    //             >
    //               {item.status}
    //             </span>
    //           </td>
    //           <td style={tableCellStyle}>{item.reason}</td>

    //         </tr>
    //       ))}
    //     </tbody>
    //   </table>
    // </div>,
    // "Wallet+": <WalletAdd />,



  };

  <style>{`
        .main-container {
         
          display: flex;
          flex-direction: column;
         
        }

         .tabs-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left:0px;
}
// .left-column {
//             width: 100%;
//             padding-right: 140px;
//             max-height: 700px;
           
//           }


/* Mobile view ke liye (max-width 768px ya 600px aapke design ke hisaab se) */
@media screen and (max-width: 768px) {
  .tabs-wrapperpayment {
    margin-left: 0;
    
  }
}


        .overviewbuttonsyy{
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          margin-top:81px;
          text-align:center;
         
        }

        .overviewbuttonsyy{
          border: none;
          border-radius: 10px;
          width: 150px;
          height: 40px;
          background-color: #d9d9d9;
          color: #000;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .overviewbuttons.active {
          background-color: #b15cd6;
        }

        .tab-content {
          margin-top: 20px;
          width: 100%;
          max-width:840px;
          
        }

        .sidebar {
          margin-top: 30px;
          max-height: 600px;
          overflow-y: auto;
        }

        .card {
          width: 100%;
          max-width: 300px;
          height: 120px;
          background: #ccc;
          border-radius: 8px;
          box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
          margin: 10px auto;
          position: relative;
          padding: 10px;
        }

        .card h5, .card p {
          color: white;
          margin: -18 !imortanant;
        }

        .overviewbuttonsyy{
         text-align:center;
          }

        
        @media (min-width: 768px) {
          .main-container {
            flex-direction: row;
            justify-content: space-between;
          }

          // .overviewbuttonsyy{
          // margin-left:29px;
          // }

          

          .left-column {
            width: 100%;
            padding-right: 95px;
            max-height: 700px;
           
          }

          .right-column {
            width: 30%;
            position: sticky;
            top: -30px;
            max-height: 700px;
            overflow-y: auto;
          }

          .card {
            margin-left: 0;
          }
            .tabs-wrapperpayment{
            margin-left:none

            }

        }

        /* Hide native scrollbars */
        .sidebar::-webkit-scrollbar,
        .left-column::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }
      `}</style>

  return (
    <div className="container-fluid">
      <div className="Row">
        <div className="col-lg-2"></div>
        <div className="Col-lg-7">


          {/* Left Section */}
          <div className="left-column" style={{}}>
            <div className="tabs-wrapperpayment ">

              <div className="overviewbuttonsyy" style={{ textAlign: 'center' }}>
                {Object.keys(tabContent).map((label) => (
                  <button style={{
                    backgroundColor: activeTab === label ? '#b15dc6' : '#d9d9d9',
                    border: 'none',
                    borderRadius: '10px',
                    width: '150px',
                    height: '40px',
                    color: 'black',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                    margin: '10px' // To simulate gap of 10px between buttons (5px top/bottom + 5px left/right)
                  }}
                    key={label}
                    className={`overviewbuttons ${activeTab === label ? "active" : ""}`}
                    onClick={() => setActiveTab(label)}
                  >
                    {label}
                  </button>


                ))}
              </div>
              <div
                className="tab-content"
                style={{
                  overflow: 'auto',
                  height: isMobile ? '700px' : '520px',
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  maxWidth: '944px',
                }}
              >
                {tabContent[activeTab]}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const tableHeaderStyle = {

  border: '1px solid #ddd',
  textAlign: 'center',
  fontWeight: 'bold',
  backgroundColor: '#b15cd6',
  color: 'white',
};

const tableCellStyle = {

  border: '1px solid #ddd',
  textAlign: 'center',
};

const evenRowStyle = {
  backgroundColor: '#f9f9f9',
};

const oddRowStyle = {
  backgroundColor: '#fff',
};
const modalOverlay = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalContent = {
  background: '#fff',
  borderRadius: '10px',
  width: '400px',
  maxWidth: '90%',
  textAlign: 'center',
};
const selectStyle = {
  height: "35px",
  marginTop: '20px',
  marginRight: "10px",
  borderRadius: "4px",
  fontWeight: "bold",
  backgroundColor: "#b15cd6",
  color: "#fff",
  marginBottom: "5px"
};

const buttonStyle = {
  height: '35px',
  marginTop: "20px",
  borderRadius: "4px",
  border: "none",
  backgroundColor: "#b15cd6",
  color: "white",
  fontWeight: 'bold',
};



export default Logisticsaccountsdata;
